export default "__VITE_ASSET__d6ade141__"